var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeleftUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.83 15.536-5.156-5.157v3.95a.5.5 0 0 1-1 0V9.172a.5.5 0 0 1 .5-.5h5.157a.5.5 0 1 1 0 1h-3.95l5.157 5.157a.5.5 0 0 1-.707.707Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.933 4.93c3.905-3.906 10.237-3.906 14.142 0 3.905 3.904 3.905 10.236 0 14.141-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142Zm.707 13.434A9 9 0 1 1 18.368 5.636 9 9 0 0 1 5.64 18.364Z",
  fill: "currentColor"
})));
export { SvgTypeleftUp as ReactComponent };
export default __webpack_public_path__ + "ea4850e2d7325d6d5382d9bfcf213f89.svg";